import React, { Component } from 'react'
import autobind from 'autobind-decorator'
import PropTypes from 'prop-types'

import WorkComment from './WorkComment'
import WorkCommentForm from './WorkCommentForm'
import WorkCommentFormStudent from './WorkCommentFormStudent'

@autobind
class WorkComments extends Component {
  render () {
    let work = this.props
    var comments = this.props.comments && this.props.comments.filter((comment) => comment.status !== 'flagged').map((comment, i) => <WorkComment comment={comment} index={i} key={i} lastComment={this.props.lastComment} onCommentFlag={this.props.onCommentFlag} />
      )

    return (
      <section className='workComments'>
        <label className='sidebar__folded__header'>
          {this.props.comments && <h4 className='sidebar__folded__title'>Comments</h4>}
        </label>
        <ul className='comments'>
          {comments}
        </ul>
        {!this.props.user.student_type && <WorkCommentForm {...work} user={this.props.user} />}
        {this.props.user.student_type && <WorkCommentFormStudent {...work} user={this.props.user} />}
      </section>
    )
  }
}

WorkComments.propTypes = {
  comments: PropTypes.array,
  lastComment: PropTypes.string,
  onCommentFlag: PropTypes.func,
  user: PropTypes.object
}

export default WorkComments



// WEBPACK FOOTER //
// ./components/work/WorkComments.js